import {
  FC,
  RefObject,
  createRef,
  forwardRef,
  useEffect,
  useState,
} from "react";
import banner from "../../Assets/homev2/hero-image.png";
import bg from "../../Assets/homev2/hero-bg.png";
import infoBg from "../../Assets/homev2/hero-infobar.png";
import underline from "../../Assets/homev2/hero-under.png";
import { useIntersectionObserver } from "../../hooks";
import ContainedButton from "./Buttons/Contained";

interface HeroProps {
  setShowOverlay: React.Dispatch<React.SetStateAction<boolean>>;
}

const Hero: FC<HeroProps> = ({ setShowOverlay }) => {
  const ref = createRef<HTMLDivElement>();
  return (
    <section
      className="w-full bg-cover overflow-hidden relative xl:max-h-[1000px]"
      style={{
        backgroundImage: `url('${bg}')`,
      }}
    >
      <div className="w-full max-w-[1500px] pt-8 md:pt-20 mx-auto relative bottom-0 pb-0">
        <div className="px-4">
          <h1 className="text-base  leading-8 md:leading-10 md:text-5xl lg:text-7xl font-medium  md:font-semibold text-black text-center">
            Everything You Need To <br />{" "}
            <span className="text-2xl font-semibold md:text-5xl lg:text-7xl ">
              {" "}
              Grow Your Business
            </span>
          </h1>
          <h2 className="text-base text-[#28274C] md:text-2xl lg:text-4xl text-center  font-normal md:mt-4">
            Sales, marketing & tech solutions for{" "}
            <span className="relative">
              <span>small & mid-size</span>

              <img
                src={underline}
                alt=""
                className="absolute hidden md:block left-0"
              />
              {/* <object
                data={underline}
                width="100%"
                height="100%"
                className="absolute left-0"
                type="image/svg+xml"
              ></object> */}
            </span>{" "}
            businesses.
          </h2>
        </div>
        <div className="w-full lg:w-[85%] mt-10 mx-auto relative bottom-0">
          <img src={banner} alt="" width="140%" height="100%" />
          <div className="absolute z-[1] bottom-4 md:bottom-10 left-[calc(50%-83.875px)]">
            <ContainedButton size="sm" onClick={() => setShowOverlay(true)}>
              <span className="flex items-center gap-2">
                <svg
                  className="md:w-5 md:h-6 w-3   h-3"
                  viewBox="0 0 19 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 20.3646V1.269C0 0.445639 0.898116 -0.0630229 1.60426 0.360401L17.5173 9.90237C18.2032 10.3137 18.2035 11.3076 17.5178 11.7193L1.60474 21.2729C0.898614 21.6969 0 21.1882 0 20.3646Z"
                    fill="black"
                  />
                </svg>
                <span className="text-sm md:text-base">Play video</span>
              </span>
            </ContainedButton>
          </div>
        </div>
      </div>
      <div
        className="w-full bottom-0  bg-[length:100%] left-0 flex  lg:flex items-center lg:items-center justify-evenly gap-4  lg:gap-8 md:px-4 py-2 md:py-9  md:bg-contain relative fit-content"
        style={{
          backgroundImage: `url('${infoBg}')`,
        }}
        ref={ref}
      >
        <div>
          <h2 className="text-white text-sm md:text-5xl font-semibold text-center">
            $<NumberAnimator ref={ref} num={37} />M
          </h2>
          <h4 className="text-[2vw] whitespace-nowrap font-light md:text-lg xl:text-2xl uppercase text-center tracking-[10%] md:font-medium text-white">
            Client revenue generated
          </h4>
        </div>
        <div className="w-[1px] h-[60px] bg-white hidden sm:block"></div>
        <div>
          <h2 className="text-white text-sm md:text-5xl font-semibold text-center">
            <NumberAnimator ref={ref} num={10} />
            K+
          </h2>
          <h4 className="text-[2vw] whitespace-nowrap  font-light md:text-lg xl:text-2xl uppercase text-center tracking-[10%] md:font-medium text-white">
            qualified meetings
          </h4>
        </div>
        <div className="w-[1px] h-[60px] bg-white hidden sm:block"></div>
        <div>
          <h2 className="text-white text-sm md:text-5xl font-semibold text-center">
            <NumberAnimator ref={ref} num={180} />+
          </h2>
          <h4 className="text-[2vw] whitespace-nowrap  font-light md:text-lg xl:text-2xl uppercase text-center tracking-[10%] md:font-medium text-white">
            satisfied clients{" "}
          </h4>
        </div>
        <div className="w-[1px] h-[60px] bg-white hidden sm:block"></div>
        <div>
          <h2 className="text-white text-sm md:text-5xl font-semibold text-center">
            <NumberAnimator ref={ref} num={42} />
          </h2>
          <h4 className="text-[2vw] whitespace-nowrap  font-light md:text-lg xl:text-2xl uppercase text-center tracking-[10%] md:font-medium text-white">
            turnkey solutions
          </h4>
        </div>
      </div>
    </section>
  );
};

export interface NumberAnimatorProps {
  num: number;
  duration?: number;
}

export const NumberAnimator = forwardRef<HTMLDivElement, NumberAnimatorProps>(
  ({ num, duration = 3500 }, ref) => {
    const [newNum, setNewNum] = useState<number>(0);
    const [trigger, setTrigger] = useState(false);
    const entry = useIntersectionObserver(ref as RefObject<Element>, {});
    const isVisible = !!entry?.isIntersecting;

    useEffect(() => {
      if (isVisible) {
        setTrigger(true);
      }
    }, [isVisible]);

    useEffect(() => {
      if (trigger) {
        const numberInterval = setTimeout(
          () => setNewNum(newNum < num ? newNum + 1 : num),
          duration / num
        );
        return () => {
          clearTimeout(numberInterval);
        };
      }
    }, [newNum, trigger]);

    return <>{newNum}</>;
  }
);

export default Hero;
